import React from "react";
import {
  Route,
  useHistory,
  Switch,
  useRouteMatch,
  Link
} from "react-router-dom";
import moment from "moment";
import Layout from "../../components/Layout";
import Container from "../../components/Container";
import { requiresClient, useAuthState } from "../../components/AuthProvider";
import DefaultBreadcrumbs from "../../components/DefaultBreadcrumbs";
import Content from "../../components/Content";
import Flex from "../../components/Flex";
import Search from "../SearchRecords/Search";
import searchOptions from "../SearchRecords/searchOptions";
import Loader from "../../components/Loader";
import createSearchPayload from "../SearchRecords/Search/createSearchPayload";
import { useMessageToast } from "../../components/MessageProvider";
import searchIdentityWarnings from "../SearchRecords/searchIdentityWarnings";
import handleResponse from "../../utils/handleFetchResponse";
import SearchResultDatatable from "../../components/SearchResultDatatable";
import SearchRecordTable from "./SearchRecordTable";
import Icon from "../../components/Icon";
import SecondaryTooltip from "../../components/SecondaryTooltip";
import fetchConfig from "../../utils/fetchConfig";
import { isImdmClient } from "../../utils/isImdmClient";
import Modal from "../../components/ModalPopup";
import Button from "../../components/Button";

import styles from "./NewSearchRecords.module.scss";
import LinkButton from "../../components/LinkButton";

const errors = {
  noSearchParams: "Please select at least one search parameter",
  invalidDate: "Kindly enter a valid date with format MM/DD/YYYY",
  invalidEmail: "Kindly enter a valid email",
  noRoot: "Root OID required when searching by extension",
  noExtension: "Extension required when searching by root OID",
  noSourceCode: "Source Code required when searching with Record ID",
  noRecordID: "Record ID required when searching with Source Code",
  invalidGender: "Gender can be Male/Female"
  // wildCardSearch: "Wildcard search (*) is NOT supported"
};

const NewSearchRecords = () => {
  const history = useHistory();
  let { path, url } = useRouteMatch();
  const [showRestrictedDialog, setshowRestrictedDialog] = React.useState(false);
  const [RestrictedEids, setRestrictedEids] = React.useState([]);
  const [isRestrictedIcon, setisRestrictedIcon] = React.useState(false);
  const [searchCriteria, setSearchCriteria] = React.useState([]);
  const [patientData, setPatientData] = React.useState([]);
  const [hcmIdExpansionList, setHcmIdExpansionList] = React.useState([]);
  const [patientsLoading, setPatientsLoading] = React.useState(false);
  const [patientsLoaded, setPatientsLoaded] = React.useState(false);
  const [warnings, setWarnings] = React.useState([]);
  const toast = useMessageToast();
  const { user } = useAuthState();
  const { selectedClient } = user.preferences;
  const isImdm = isImdmClient(selectedClient);
  const fetchFhirRecords = () => {
    const data = createSearchPayload(
      searchCriteria,
      selectedClient.oid,
      undefined,
      isImdm
    );
    setPatientsLoading(true);
    setWarnings([]);
    let includeRelatedIdentities = true;
    for (let i = 0; i < searchCriteria.length; i++) {
      if (
        searchCriteria[i].key === "golden_id" ||
        searchCriteria[i].key === "record_id"
      ) {
        includeRelatedIdentities = !(isImdm && true);
      }
    }
    const url = isImdm
      ? `${process.env.REACT_APP_CLIENT_IDENTITY_SERVICE_DOMAIN}/patient/aggregates?include_related_identities=${includeRelatedIdentities}`
      : `${process.env.REACT_APP_CLIENT_IDENTITY_SERVICE_DOMAIN}/patient/aggregates`;
    const mockUrl = `/fhirPatients.json`;
    const config = {
      method: "POST",
      body: JSON.stringify(data),
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        clientId: selectedClient.oid
      }
    };
    fetch(...fetchConfig(url, mockUrl, config))
      .then(handleResponse)
      .then(response => {
        let responseData = response.data;
        let isrestricted = response.isRestricted == "true" ? true : false;
        let restrictedeids = response.RestrictedEids;
        if (
          isrestricted &&
          restrictedeids != "null" &&
          restrictedeids.length > 0
        ) {
          restrictedeids = restrictedeids.replaceAll("Patient/", "");
          setRestrictedEids(restrictedeids);
          setshowRestrictedDialog(true);
        } else if (
          restrictedeids != null &&
          restrictedeids != "null" &&
          restrictedeids.length > 0
        ) {
          restrictedeids = restrictedeids
            .replaceAll(/Patient\/|\[|\]|\s/gi, "")
            .split(",");
          setRestrictedEids(restrictedeids);
          setisRestrictedIcon(true);
        }

        /***
         * This is an hack for showing resulted EID on the top, if search is with record id and source
         */
        if (
          searchCriteria &&
          searchCriteria.length === 2 &&
          (searchCriteria[0].key === "record_id" ||
            searchCriteria[0].key === "source_code") &&
          (searchCriteria[1].key === "record_id" ||
            searchCriteria[1].key === "source_code")
        ) {
          if (responseData.length > 0) {
            let tempData;
            let index;
            let eidFound = false;
            let recordiId =
              searchCriteria[0].key === "record_id"
                ? searchCriteria[0].value
                : searchCriteria[1].value;
            let sourceCode =
              searchCriteria[0].key === "source_code"
                ? searchCriteria[0].value
                : searchCriteria[1].value;
            responseData.every((element, idx) => {
              element.identifier.every(idf => {
                if (
                  idf.system &&
                  sourceCode &&
                  idf.system.toUpperCase() === sourceCode.toUpperCase() &&
                  idf.value === recordiId
                ) {
                  eidFound = true;
                  index = idx;
                  tempData = element;
                  return false;
                }
                return true;
              });

              return !eidFound;
            });
            if (eidFound && index !== 0) {
              responseData.splice(index, 1);
              responseData = [tempData, ...responseData];
            }
          }
        }
        // the first address in the response data is displayed in the search results
        // sort the addresses to display the primary address when available
        responseData.map(res => {
          return (
            res.address &&
            res.address.sort((a, b) => {
              if (
                (a.extension &&
                  b.extension &&
                  a.extension.filter(e => e.valueString === "PERPRIMERRES")
                    .length ===
                    b.extension.filter(
                      e => e.valueString && e.valueString === "PERPRIMERRES"
                    ).length) ||
                (!a.extension && !b.extension)
              ) {
                return 0;
              } else if (
                (a.extension &&
                  b.extension &&
                  a.extension.filter(e => e.valueString === "PERPRIMERRES")
                    .length >
                    b.extension.filter(e => e.valueString === "PERPRIMERRES")
                      .length) ||
                (a.extension && !b.extension)
              ) {
                return -1;
              } else if (
                (a.extension &&
                  b.extension &&
                  a.extension.filter(e => e.valueString === "PERPRIMERRES")
                    .length <
                    b.extension.filter(e => e.valueString === "PERPRIMERRES")
                      .length) ||
                (!a.extension && b.extension)
              ) {
                return 1;
              }
            })
          );
        });
        setPatientData(responseData);
        setHcmIdExpansionList(
          responseData.map(res => {
            return { id: res.id, expanded: false };
          })
        );
        setPatientsLoading(false);
        setPatientsLoaded(true);
      })
      .catch(error => {
        setPatientData([]);
        setPatientsLoading(false);
        if (
          "SyntaxError: Unexpected token < in JSON at position 0".localeCompare(
            error
          ) === 0
        ) {
          toast.error("Aggregates not found");
        } else if (error.status === 500) {
          toast.error(error.message);
        } else if (error.metaData.error) {
          toast.error(error.metaData.error);
        } else {
          toast.error("Connection to client identity service failed");
        }
      });
  };

  const ShowRestrictedDialog = () => {
    return (
      <Modal
        open={showRestrictedDialog}
        onClose={() => setshowRestrictedDialog(false)}
        maxheight={{ "max-height": "90%" }}
      >
        <h4 style={{ textAlign: "center", marginBottom: "20px" }}>
          You are not authorized to view EID's {RestrictedEids} due to data
          governance restriction/compliance.
        </h4>
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Button
            onClick={() => {
              setshowRestrictedDialog(false);
            }}
          >
            OK
          </Button>
        </div>
      </Modal>
    );
  };

  const onSearchHandler = () => {
    setPatientData([]);
    setPatientsLoaded(false);
    const warningMessages = searchIdentityWarnings([...searchCriteria]);
    if (warningMessages.length) {
      setWarnings([...warningMessages]);
      return;
    }
    fetchFhirRecords();
  };

  React.useEffect(() => {
    setSearchCriteria([]);
    setPatientData([]);
    setPatientsLoaded(false);
    setPatientsLoading(false);
    setWarnings([]);
  }, [user.preferences.selectedClient]);

  React.useEffect(() => {
    if (patientsLoaded) {
      toast.info("Client Changed to " + selectedClient.oid);
      history.push(`/search-identities-new`);
    }
  }, [selectedClient.oid]);

  const detailOptionsCell = ({ row }) => {
    return (
      <SecondaryTooltip toolTipMsg="Record List">
        <span className={styles.base}>
          <Link
            to={{
              pathname: `${url}/${selectedClient.oid}/view/${row.original.id}/`,
              state: {
                preLoadedSearchCriteria: searchCriteria
              }
            }}
            style={{ textDecoration: "none" }}
          >
            <button
              className={styles.nextArrowIcon}
              onClick={() => {
                rowClickHandler(row.original.id);
              }}
            >
              <Icon size="1.5rem" type="arrow_right" />
            </button>
          </Link>
        </span>
      </SecondaryTooltip>
    );
  };

  const ssnCell = ({ row }) => {
    let ssnValue = "-";
    if (row && row.original && row.original.identifier) {
      const idArray = row.original.identifier.filter(
        identifiers =>
          identifiers.system === "http://hl7.org/fhir/sid/us-ssn" &&
          !(
            identifiers.extension &&
            identifiers.extension.some(
              ext => ext.url === "additionalDataFromRecords"
            )
          )
      );
      ssnValue =
        idArray && idArray[0] && idArray[0].value ? idArray[0].value : "-";
    }
    return ssnValue;
  };

  const mbiCell = ({ row }) => {
    let mbiValue = "-";
    if (row && row.original && row.original.identifier) {
      const idArray = row.original.identifier.filter(
        identifiers =>
          identifiers.system === "http://hl7.org/fhir/sid/us-mbi" &&
          !(
            identifiers.extension &&
            identifiers.extension.some(
              ext => ext.url === "additionalDataFromRecords"
            )
          )
      );
      mbiValue =
        idArray && idArray[0] && idArray[0].value ? idArray[0].value : "-";
    }
    return mbiValue;
  };

  const hicnCell = ({ row }) => {
    let hicnValue = "-";
    if (row && row.original && row.original.identifier) {
      const idArray = row.original.identifier.filter(
        identifiers =>
          identifiers.system === "http://hl7.org/fhir/sid/us-medicare" &&
          !(
            identifiers.extension &&
            identifiers.extension.some(
              ext => ext.url === "additionalDataFromRecords"
            )
          )
      );
      hicnValue =
        idArray && idArray[0] && idArray[0].value ? idArray[0].value : "-";
    }
    return hicnValue;
  };

  const isrestrictedcell = ({ row }) => {
    if (isRestrictedIcon && RestrictedEids.includes(row.original.id)) {
      return (
        <SecondaryTooltip toolTipMsg="Restricted EID(Non-US)">
          <LinkButton
            icon="alert_filled"
            style={{
              color: "blue"
            }}
          />
        </SecondaryTooltip>
      );
    } else return null;
  };

  const SEARCH_RESULTS_COLUMNS = [
    {
      Header: isImdm ? "EID" : "HCM ID",
      accessor: "id"
    },
    {
      Header: "SSN",
      accessor: "ssn",
      Cell: ssnCell
    },
    {
      Header: "MBI",
      accessor: "mbi",
      Cell: mbiCell
    },

    {
      Header: "HICN",
      accessor: "hicn",
      Cell: hicnCell
    },

    {
      Header: "Given Name",
      accessor: "name[0].given",
      Cell: ({ value }) => {
        return value
          ? value.map((name, i) => (value[i + 1] ? name + ", " : name))
          : "-";
      }
    },
    {
      Header: "Family Name",
      accessor: "name[0].family",
      Cell: ({ value }) => {
        return value ? value : "-";
      }
    },
    {
      Header: "Gender",
      accessor: "gender",
      Cell: ({ value }) => {
        return value ? value.charAt(0).toUpperCase() + value.slice(1) : "-";
      }
    },
    {
      Header: "Date Of Birth",
      accessor: "birthDate",
      Cell: ({ value }) => {
        return value ? moment(value).format("L") : "-";
      }
    },
    {
      Header: "Address Line",
      accessor: "address[0].line",
      Cell: ({ value }) => {
        return value ? value.join(", ") : "-";
      }
    },
    {
      Header: "City",
      accessor: "address[0].city",
      Cell: ({ value }) => {
        return value ? value : "-";
      }
    },
    {
      Header: "Postal Code",
      accessor: "address[0].postalCode",
      Cell: ({ value }) => {
        return value ? value : "-";
      }
    },
    {
      accessor: "RestrictedEID",
      sticky: "right",
      style: {
        right: 0,
        zIndex: 9999,
        minWidth: "50px"
      },
      Cell: isrestrictedcell
    },
    {
      accessor: "moreoptions",
      sticky: "right",
      style: {
        right: 0,
        zIndex: 9999,
        minWidth: "50px"
      },
      Cell: detailOptionsCell
    }
  ];

  const rowClickHandler = gid => {
    const expandedArray = [...hcmIdExpansionList];
    const clickedAggregate = expandedArray.find(ar => ar.id === gid);
    clickedAggregate.expanded = !clickedAggregate.expanded;
    setHcmIdExpansionList(expandedArray);
  };

  //ms in ms_clientId and ms_gid stands for manual stewardship
  return (
    <Switch>
      <Route path={`${url}/:ms_clientId/view/:ms_gid/`}>
        <SearchRecordTable />
      </Route>
      <Route
        path={`${url}/:ms_clientId/quarantine/:quar_sourceId/:quar_recordId/`}
      >
        <SearchRecordTable />
      </Route>
      <Layout className={styles.base}>
        <Route exact route={path}>
          <Container>
            <Flex gutter={3}>
              <Flex.Item span={12}>
                <DefaultBreadcrumbs />
              </Flex.Item>
              <Flex.Item span={12}>
                <Content>
                  <h3>Search Identities</h3>
                </Content>
              </Flex.Item>
              <Flex.Item span={12}>
                <span className={styles.base}>
                  <Search
                    criteria={searchCriteria}
                    onChange={setSearchCriteria}
                    onSearch={onSearchHandler}
                    options={searchOptions}
                  />
                  <div className={styles.searchInstruction}>
                    Supported Search Criteria: Given name, Family name, Date of
                    Birth, City, State, Country, Gender(male/female), Postal
                    Code, HCM ID/EID, Root OID and Extension.
                  </div>
                </span>
                {warnings.map(warning => (
                  <div className={styles.error} key={warning}>
                    * {errors[warning]}
                  </div>
                ))}
              </Flex.Item>
              <Flex.Item span={12}>
                <div className={styles.base}>
                  <div className={styles.searchTable}>
                    {ShowRestrictedDialog()}
                    <Loader loading={patientsLoading}>
                      {" "}
                      {patientData ? (
                        <SearchResultDatatable
                          data={patientData}
                          columns={SEARCH_RESULTS_COLUMNS}
                          rowClick={rowClickHandler}
                          expandedArray={hcmIdExpansionList}
                        />
                      ) : (
                        <span>No results found for this search!</span>
                      )}
                    </Loader>
                  </div>
                </div>
              </Flex.Item>
            </Flex>
          </Container>
        </Route>
      </Layout>
    </Switch>
  );
};

export default requiresClient(NewSearchRecords);
